<div class="processing-status-models">

  <sc-master-detail [selection]="[selectedModel]" [data]="models" (selectionChanged)="onSelectionChanged($event);" [newStyle]="true"
    (addEntry)="onAddEntry($event);" [showDelete]="false" (deleteEntry)="onDeleteEntry($event);">

    <form #statusModelForm="ngForm" class="form">
      <div class="processing-status-model-details" *ngIf="workingCopyDetails">
        <div class="scrollable">
          <div class="form-box">
            <sc-dictionary-field [model]="workingCopyDetails.name" [defaultLabel]="'name'"
              (dictionaryChanged)="onDictionaryChanged()"
              [labelDictionaryKey]="'tmc-yard.common.name'" [required]="true"
              [maxlength]="255">
            </sc-dictionary-field>
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.processing-status-models.key"></sc-dictionary-label>
              </mat-label>
              <input [(ngModel)]="workingCopyDetails.key" name="key" matInput
                [required]="true" [maxlength]="255" />
            </mat-form-field>
            <mat-form-field appearance="fill">
              <mat-label>
                <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.processing-status-models.index"></sc-dictionary-label>
              </mat-label>
              <input [(ngModel)]="workingCopyDetails.index" name="index" matInput
                [required]="true" type="number" />
            </mat-form-field>
            <mat-checkbox [(ngModel)]="workingCopyDetails.deactivated" name="deactivated">
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.processing-status-models.deactivated"></sc-dictionary-label>
            </mat-checkbox>
          </div>

          <h2 class="mat-h2 processing-status-title">
            <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.processing-status-models.status.title"></sc-dictionary-label>
          </h2>

          <div class="form-box" cdkDropList (cdkDropListDropped)="drop($event)">
            <ng-container *ngFor="let status of workingCopyDetails.processingStatus">
              <div class="draggable-form-box grid" cdkDrag *ngIf="!status.deleted">

                <mat-form-field style="grid-column: 1; grid-row: 1;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.processing-status-models.status.key"></sc-dictionary-label>
                  </mat-label>
                  <input matInput [(ngModel)]="status.key" name="key" name="{{'status_'+status.id+'_key'}}"
                    required [readonly]="isLoading">
                </mat-form-field>

                <div style="grid-column: 2; grid-row: 1;">
                  <sc-dictionary-field [model]="status.name" [defaultLabel]="'name'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.common.name'" [required]="false"
                    [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <mat-form-field style="grid-column: 3; grid-row: 1;" appearance="fill">
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="tmc-yard.entity.processing-status.color"></sc-dictionary-label>
                  </mat-label>
                  <app-color-picker (colorSelected)="colorPickerChanged($event)" [(ngModel)]="status.color"
                    name="{{'status_'+status.id+'_color'}}">
                  </app-color-picker>
                </mat-form-field>

                <div style="grid-column: 1; grid-row: 2;">
                  <sc-dictionary-field [model]="status.backward" [defaultLabel]="'backward'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.ui.admin.processing-status-models.status.backward'"
                    [required]="false" [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <div style="grid-column: 2 / span 2; grid-row: 2;">
                  <sc-dictionary-field [model]="status.forward" [defaultLabel]="'forward'"
                    (dictionaryChanged)="onDictionaryChanged()"
                    [labelDictionaryKey]="'tmc-yard.ui.admin.processing-status-models.status.forward'" [required]="false"
                    [maxlength]="255">
                  </sc-dictionary-field>
                </div>

                <div class="centered" style="grid-column: 4; grid-row: 1">
                  <i cdkDragHandle class="fa-light fa-bars drag-handle"></i>
                </div>

                <div style="grid-column: 4; grid-row: 2" class="centered">
                  <button mat-flat-button class="small-button remove-button" (click)="removeStatus(status)"
                    [disabled]="isLoading"><sc-icon iconClass="fa-minus"></sc-icon></button>
                </div>
              </div>
            </ng-container>
            <sc-content-spacer vertical></sc-content-spacer>
            <sc-flex centered>
              <sc-add-action-button large (click)="addStatus()" [disabled]="isLoading"></sc-add-action-button>
            </sc-flex>
          </div>
        </div>

      </div>
    </form>

    <ng-template masterDetailToolbar>
      <sc-cancel-button class="config-changed-button" (click)="cancel()" [disabled]="!cancelEnabled"></sc-cancel-button>
      <sc-content-spacer></sc-content-spacer>
      <sc-save-button primary class="config-changed-button" (click)="save()" [disabled]="!saveEnabled"></sc-save-button>
    </ng-template>

  </sc-master-detail>

</div>
